import Vue from 'vue'
const url = window.$website.url
const request = Vue.prototype.$axios;
const baseUrl = url + '/user'



export const login = (username, password) => request({
  url: baseUrl + '/login',
  method: 'post',
  params: {
    "username": username,
    "password": password
  }
});
